import Vue from 'vue'
import App from './App.vue'
import store from './store'

import firebase from 'firebase/app'
import 'firebase/firestore'

import VueTimeago from 'vue-timeago'

Vue.use(VueTimeago, {
  name: 'Timeago',
  locale: 'en',
})

Vue.config.productionTip = false

firebase.initializeApp({
  apiKey: 'AIzaSyCQIIncm2WPhlVnvfPJk1yF3_QxzUMSdwA',
  authDomain: 'shnaps-74ef5.firebaseapp.com',
  projectId: 'shnaps-74ef5',
})

window.db = firebase.firestore()

const guid = () => {
  var nav = window.navigator
  var screen = window.screen
  var guid = nav.mimeTypes.length
  guid += nav.userAgent.replace(/\D+/g, '')
  guid += nav.plugins.length
  guid += screen.height || ''
  guid += screen.width || ''
  guid += screen.pixelDepth || ''

  return guid
}

const setCookie = (name, value, days) => {
  let expires = ''
  if (days) {
    let date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }
  if (window.location.hostname.match(/shnaps\.io/)) {
    // TODO: fix for the real domain
    document.cookie =
      name + '=' + value + expires + '; domain=.shnap.me; path=/'
  } else {
    // if testing locally
    document.cookie = name + '=' + value + expires + '; path=/'
  }
}

const readCookie = name => {
  let nameEQ = name + '='
  let ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

const clearCookie = name => {
  setCookie(name, '', -1)
}

const createDocumentAndToken = () => {
  window.db
    .collection('users')
    .where('guids', 'array-contains', String(guid()))
    .get()
    .then(res => {
      if (!res.empty) {
        const id = res.docs[0].id
        const data = res.docs[0].data()

        setCookie('token', id)

        store.commit('SET_USERS_STATE', { user: id, moderator: data.moderator })

        window.db.collection('events').add({
          action: 'loginWithTag',
          by: window.db.doc('users/' + res.docs[0].id),
          submittedAt: Date.now(),
        })
      } else {
        // could not find existing doc
        window.db
          .collection('users')
          .add({
            guids: [guid()],
            moderator: false,
          })
          .then(doc => {
            const id = doc.id
            setCookie('token', id)

            store.commit('SET_USERS_STATE', { user: id, moderator: false })

            window.db.collection('events').add({
              action: 'signup',
              by: window.db.doc('users/' + doc.id),
              submittedAt: Date.now(),
            })
          })
      }
    })
}

const loginWithDoc = (id, data) => {
  store.commit('SET_USERS_STATE', { user: id, moderator: data.moderator })

  window.db.collection('events').add({
    action: 'login',
    by: window.db.doc('users/' + id),
    submittedAt: Date.now(),
  })
}

const token = readCookie('token')
if (token) {
  window.db
    .collection('users')
    .doc(token)
    .get()
    .then(doc => {
      if (doc.exists) {
        const data = doc.data()
        if (data.guids.includes(String(guid()))) loginWithDoc(doc.id, data)
        else {
          window.db
            .collection('users')
            .where('guids', 'array-contains', String(guid()))
            .get()
            .then(res => {
              if (!res.empty) {
                const id = res.docs[0].id
                const data = res.docs[0].data()

                setCookie('token', id)

                store.commit('SET_USERS_STATE', {
                  user: id,
                  moderator: data.moderator,
                })

                window.db.collection('events').add({
                  action: 'loginSwitch',
                  by: window.db.doc('users/' + res.docs[0].id),
                  submittedAt: Date.now(),
                })
              } else {
                window.db.doc('users/' + doc.id).update({
                  guids: firebase.firestore.FieldValue.arrayUnion(guid()),
                })

                store.commit('SET_USERS_STATE', {
                  user: doc.id,
                  moderator: data.moderator,
                })

                window.db.collection('events').add({
                  action: 'loginWithAddition',
                  by: window.db.doc('users/' + doc.id),
                  submittedAt: Date.now(),
                })
              }
            })
        }
      } else {
        clearCookie('token')
        createDocumentAndToken()
      }
    })
} else {
  createDocumentAndToken()
}

new Vue({
  store,
  render: h => h(App),
}).$mount('#app')
